<template>
  <div class="details-reader__wrp-array">
    <a-table
      size="small"
      :data-source="addresses"
      :row-key="address=>`${address.chainId}-${address.address}`"
      :pagination="false"
      :columns="columns"
    >
      <template
        slot="title"
      >
        <span>{{ globalize('eth-addresses.title') }}</span>
      </template>
      <template
        slot="url-column"
        slot-scope="url, item"
      >
        <copyable
          class="app-key-value__value"
          :copy-text="item.address"
        >
          <a
            target="_blank"
            :href="item.url"
            :title="item.address">
            {{ shortener(item.address) }}
          </a>
        </copyable>
      </template>
    </a-table>
  </div>
</template>

<script>
import ATable from 'ant-design-vue/lib/table'
import { globalize } from '@/vue/filters/globalize'
import { shortener } from '@/js/helpers/string'
import Copyable from '@/vue/common/copyable/Copyable'

const columns = ctx => {
  /* eslint-disable-next-line */
  const h = ctx.$createElement
  return [
    {
      dataIndex: 'url',
      key: 'url',
      title: 'URL',
      scopedSlots: { customRender: 'url-column' },
    },
    {
      dataIndex: 'type',
      key: 'type',
      title: globalize('eth-addresses.type'),
    },
    {
      dataIndex: 'chainName',
      key: 'chainName',
      title: globalize('eth-addresses.chain-name'),
    },
    {
      dataIndex: 'chainId',
      key: 'chainId',
      title: globalize('eth-addresses.chain-id'),
    },
  ]
}

export default {
  name: 'eth-addresses',
  components: {
    Copyable,
    ATable,
  },
  props: {
    addresses: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    columns () {
      const result = columns(this)

      return result
    },
  },
  methods: {
    shortener,
    globalize,
  },
}
</script>

<style lang="scss">
  @import '~ant-design-vue/lib/table/style/index.css';

</style>
